import { create } from "zustand"

export enum SendBirdView {
  CHANNEL_LIST = "channel-list",
  CHANNEL_DETAIL = "channel-detail",
}

interface MobileViewStore {
  view: SendBirdView
  setView: (view: SendBirdView) => void
}

const useMobileViewStore = create<MobileViewStore>()((set) => ({
  view: SendBirdView.CHANNEL_LIST,
  setView: (view: SendBirdView) => set({ view }),
}))

export default useMobileViewStore
